import { AxiosService } from './axiosService';

export class UnitConversionsService extends AxiosService {
    async getUnitConversions(sortState, page, pageSize) {
        try {
            const { data } = await this.axios.post('/unitconversions', {
                SortBy: sortState[0].fieldName,
                OrderBy: sortState[0].dir,
                PageSize: pageSize,
                PageIndex: page
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async createUnitConversion(unitConversion) {
        try {
            const { data } = await this.axios.post('/unitconversions/create', unitConversion);
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async updateUnitConversion(unitConversion) {
        try {
            const { data } = await this.axios.put('/unitconversions/update', unitConversion);
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteUnitConversion(sourceUnit, targetUnit) {
        try {
            const { data } = await this.axios.delete(
                `/unitconversions?sourceUnit=${encodeURIComponent(sourceUnit)}&targetUnit=${encodeURIComponent(targetUnit)}`
            );
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const unitConversionsService = new UnitConversionsService();
